import React, { Component } from 'react';
import ModalFull from '../../components/helpers/ModalFull';
import Input from '../../components/forms/Input';
import { THEME_WHITE } from '../../constants/styling/themes';
import searchIcon from '../../assets/images/search_white.svg';
import Results from '../../components/application/timetable/search/Results';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectors from '../../selectors/events/search';
import { closeSearch, searchInput, clearSearch, search } from '../../actions/events/search';
import { showEntry } from '../../actions/events/entries';

class Search extends Component {
    constructor(props) {
        super(props);
        this.searchInputRef = React.createRef();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.open === false && this.props.open === true) {
            this.searchInputRef.current.focus(100);
        }
    }
    _search = query => {
        this.props.searchInput(query);
        this.props.search(query);
    };
    render() {
        return (
            <ModalFull open={this.props.open} onClose={this.props.closeSearch}>
                <div className="ckp-events-search">
                    <Input
                        ref={this.searchInputRef}
                        value={this.props.query}
                        onChange={this._search}
                        icon={searchIcon}
                        label="Search the line up..."
                        theme={THEME_WHITE}
                        type="search"
                        className="ckp-events-search-input is-full-width"
                        onClear={this.props.clearSearch}
                    />
                    <Results
                        onClickResult={this.props.showEntry}
                        fetching={this.props.fetching}
                        query={this.props.query}
                        results={this.props.results}
                    />
                </div>
            </ModalFull>
        );
    }
}

const mapStateToProps = state => ({
    results: selectors.searchResultsSelector(state),
    query: selectors.searchQuerySelector(state),
    open: selectors.searchOpenSelector(state),
    fetching: selectors.isFetchingSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ closeSearch, searchInput, clearSearch, showEntry, search }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Search);
